import React, { useState } from 'react';

function DetailSection({ title, items }) {
  if (!items || !items.length) return null;
  return (
    <section className="detail-section">
      <h4>{title}</h4>
      {items.map((item) => (
        <p key={item.slice(0, 24)}>{item}</p>
      ))}
    </section>
  );
}

function JobCard({ job, onApply }) {
  const [open, setOpen] = useState(false);

  return (
    <article className="job-card">
      <div className="job-summary">
        <div>
          <h3 className="job-name">{job.name}</h3>
          <div className="job-department">{job.department}</div>
        </div>
        <div className="job-actions">
          <button
            className="detail-button"
            type="button"
            aria-expanded={open}
            onClick={() => setOpen(!open)}
          >
            {open ? '收起详情' : '投递须知'}
          </button>
          <button className="apply-button" type="button" onClick={() => onApply(job.id)}>
            立即投递
          </button>
        </div>
      </div>
      <div className={`job-detail${open ? ' open' : ''}`} id={`detail-${job.id}`}>
        <DetailSection title="招聘数量" items={['若干']} />
        <DetailSection title="岗位职责" items={job.duties} />
        <DetailSection title="工作、任职经历要求" items={job.requirements} />
        <DetailSection title="专业要求" items={job.major} />
        <DetailSection title="学历要求" items={job.education} />
        <DetailSection title="年龄要求" items={job.age} />
      </div>
    </article>
  );
}

export default JobCard;
